import React from 'react'

import moment from 'moment'
import { MaintenanceEvent } from '../../domain/Event'

interface Props {
    data: MaintenanceEvent
}

class Maintenance extends React.Component<Props> {
    public render() {
        const start = this.props.data.eventDate
        const end = this.props.data.eventEnded ? this.props.data.eventEnded : null
        const diff = end ? moment.duration(moment(end).diff(moment(start))) : null

        const dateFormat = 'dddd, MMMM Do YYYY, H:mm:ss'

        return (
            <div className="box event-box">
                <div className="box-body">
                    <div className="timeline-body">
                        The maintenance {`"${this.props.data.name}"`} started {moment(start).format(dateFormat)}
                        {end && moment(end).isBefore(moment()) && diff ? (
                            <span> and ran for {diff.humanize()}</span>
                        ) : (
                            <span> and is still ongoing until {end ? moment(end).format(dateFormat) : 'eternity'}.</span>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Maintenance
